import React, { Component } from 'react';
import { Button, Modal, HeadingText, BodyText } from '@paypalcorp/pp-react';
import TemplateData, { localsMessages } from '../../utility/getTemplateData';
import { sanitize } from '../../utility/domUtils';
import PropTypes from 'prop-types';
let texts = localsMessages('common/recurring-checkbox');

const orgname = TemplateData.donationName ? TemplateData.donationName : '';

export class RecurringOverlay extends Component {
  handleClose = () => {
    this.props.closeRecurringOverlay();
  };

  noThanks_closeModal = (event) => {
    this.props.onMakeOneTimeDonation();
  };

  onContinue = (event) => {
    this.props.onContinue();
  };

  render() {
    let {
      rp: {
        signupHeader,
        dialogp1,
        dialogp2,
        dialogp3,
        continueBtn,
        noThanksBtn,
      } = {},
    } = texts || {};

    dialogp1 = dialogp1 && dialogp1.replace('{orgName}', sanitize(orgname));

    return (
      <Modal
        className="recurring-signup-overpanel"
        overpanel
        title=""
        isOpen={this.props.isOpen}
        onClose={this.handleClose}
        hideLogo
        closeOnBackgroundClick={false}
      >
        <div className="modal-body">
          <div>
            <div className="ppvx_row">
              <div className="ppvx_col-12">
                <div className="icon-container">
                  <img
                    src="https://www.paypalobjects.com/images/Cause/icRecurring.svg"
                    alt="icRecurring"
                  />
                </div>
              </div>
            </div>
            <div className="ppvx_row">
              <div className="ppvx_col-12">
                <HeadingText size="lg">{signupHeader}</HeadingText>
              </div>
            </div>
            <div className="ppvx_row">
              <div className="ppvx_col-12"></div>
            </div>
            <div className="ppvx_row">
              <div className="ppvx_col-12"></div>
            </div>

            <div className="ppvx_row">
              <div className="ppvx_col-12">
                <div className="content">
                  <div className="content-row">
                    <div className="icon-column">&#9679;</div>
                    <BodyText className="text-column">{dialogp1}</BodyText>
                  </div>
                  <div className="content-row">
                    <div className="icon-column">&#9679;</div>
                    <BodyText className="text-column">{dialogp2}</BodyText>
                  </div>
                  <div className="content-row">
                    <div className="icon-column">&#9679;</div>
                    <BodyText className="text-column">{dialogp3}</BodyText>
                  </div>
                </div>
              </div>
            </div>

            <div className="actions">
              <div className="ppvx_row mb-16">
                <div className="ppvx_col-12 ppvx_justify-content-center ppvx_d-flex">
                  <Button className="btn-wide" onClick={this.props.onContinue}>
                    {continueBtn}
                  </Button>
                </div>
              </div>

              <div className="ppvx_row">
                <div className="ppvx_col-12 ppvx_justify-content-center ppvx_d-flex">
                  <Button
                    secondary
                    className="btn-wide"
                    id="noThanks"
                    onClick={this.noThanks_closeModal}
                  >
                    {noThanksBtn}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

RecurringOverlay.propTypes = {
  closeRecurringOverlay: PropTypes.func,
  onMakeOneTimeDonation: PropTypes.func,
  onContinue: PropTypes.func,
  isOpen: PropTypes.bool,
};

export default RecurringOverlay;
